module.exports = __webpack_public_path__ + "static/media/selectInputArrow.198e5d04.svg";